import React from 'react';
import { Fragment } from 'react';

const Whitespace = ({n = 1}) => {
    
    
    return (
        <>
            {Array
                .from({length: n}, (v, i) => i)
                .map(i => (<Fragment key={i} >&nbsp;</Fragment>))
            }
        </>
    )
}

export default Whitespace